import { defineStore } from 'pinia'
import {
  reactive,
  readonly,
  toRefs,
} from 'vue'
import { ExampleStreamViewTemplates } from '~domain/cameras/ViewTemplate'
import {
  hubApi,
} from '~services/api'


export const useExampleDefinitionsStore = defineStore('exampleDefinitions', () => {
  const state = reactive({
    exampleStreamViewTemplates: [] as ExampleStreamViewTemplates[],
    loading: false,
  })

  const actions = {
    async loadExampleStreamViewTemplates (): Promise<void> {
      state.loading = true
      try {
        if (state.exampleStreamViewTemplates.length === 0) {
          const { data } = await hubApi.viewTemplates.listExampleStreamViewTemplates()
          state.exampleStreamViewTemplates = data.items.map(ExampleStreamViewTemplates.fromResponse)
        }
      } finally {
        state.loading = false
      }
    },

    setState (params: Partial<typeof state>): void {
      Object.assign(state, params)
    },
  }

  const getters = {
    getExampleStreamViewTemplates (definitionId: string): ExampleStreamViewTemplates | undefined {
      return state.exampleStreamViewTemplates.find(
        viewTemplate => viewTemplate.definitionId === definitionId,
      )
    },
  }

  return {
    ...toRefs(readonly(state)),
    ...actions,
    ...getters,
  }
})
